// Catálogo oficial de distritos de Hacienda (dependiente de departamento + municipio).
// Fuente: catálogo MH provisto por el usuario (docs/districts.csv).
// Actúa como respaldo si GET /catalog/districts/{deptCode}/{cityCode} falla.
export const districtsOptions = [
  {
    value: "03",
    label: "Atiquizaya",
    municipality: "13",
    department: "01"
  },
  {
    value: "05",
    label: "El Refugio",
    municipality: "13",
    department: "01"
  },
  {
    value: "09",
    label: "San Lorenzo",
    municipality: "13",
    department: "01"
  },
  {
    value: "12",
    label: "Turín",
    municipality: "13",
    department: "01"
  },
  {
    value: "01",
    label: "Ahuachapán",
    municipality: "14",
    department: "01"
  },
  {
    value: "02",
    label: "Apaneca",
    municipality: "14",
    department: "01"
  },
  {
    value: "04",
    label: "Concepción de Ataco",
    municipality: "14",
    department: "01"
  },
  {
    value: "11",
    label: "Tacuba",
    municipality: "14",
    department: "01"
  },
  {
    value: "06",
    label: "Guaymango",
    municipality: "15",
    department: "01"
  },
  {
    value: "07",
    label: "Jujutla",
    municipality: "15",
    department: "01"
  },
  {
    value: "08",
    label: "San Francisco Menéndez",
    municipality: "15",
    department: "01"
  },
  {
    value: "10",
    label: "San Pedro Puxtla",
    municipality: "15",
    department: "01"
  },
  {
    value: "06",
    label: "Masahuat",
    municipality: "14",
    department: "02"
  },
  {
    value: "07",
    label: "Metapán",
    municipality: "14",
    department: "02"
  },
  {
    value: "11",
    label: "Santa Rosa Guachipilín",
    municipality: "14",
    department: "02"
  },
  {
    value: "13",
    label: "Texistepeque",
    municipality: "14",
    department: "02"
  },
  {
    value: "10",
    label: "Santa Ana",
    municipality: "15",
    department: "02"
  },
  {
    value: "02",
    label: "Coatepeque",
    municipality: "16",
    department: "02"
  },
  {
    value: "04",
    label: "El Congo",
    municipality: "16",
    department: "02"
  },
  {
    value: "01",
    label: "Candelaria de la Frontera",
    municipality: "17",
    department: "02"
  },
  {
    value: "03",
    label: "Chalchuapa",
    municipality: "17",
    department: "02"
  },
  {
    value: "05",
    label: "El Porvenir",
    municipality: "17",
    department: "02"
  },
  {
    value: "08",
    label: "San Antonio Pajonal",
    municipality: "17",
    department: "02"
  },
  {
    value: "09",
    label: "San Sebastián Salitrillo",
    municipality: "17",
    department: "02"
  },
  {
    value: "12",
    label: "Santiago de la Frontera",
    municipality: "17",
    department: "02"
  },
  {
    value: "07",
    label: "Juayúa",
    municipality: "17",
    department: "03"
  },
  {
    value: "08",
    label: "Nahuizalco",
    municipality: "17",
    department: "03"
  },
  {
    value: "10",
    label: "Salcoatitán",
    municipality: "17",
    department: "03"
  },
  {
    value: "13",
    label: "Santa Catarina Masahuat",
    municipality: "17",
    department: "03"
  },
  {
    value: "09",
    label: "Nahulingo",
    municipality: "18",
    department: "03"
  },
  {
    value: "11",
    label: "San Antonio del Monte",
    municipality: "18",
    department: "03"
  },
  {
    value: "14",
    label: "Santo Domingo de Guzmán",
    municipality: "18",
    department: "03"
  },
  {
    value: "15",
    label: "Sonsonate",
    municipality: "18",
    department: "03"
  },
  {
    value: "16",
    label: "Sonzacate",
    municipality: "18",
    department: "03"
  },
  {
    value: "02",
    label: "Armenia",
    municipality: "19",
    department: "03"
  },
  {
    value: "03",
    label: "Caluco",
    municipality: "19",
    department: "03"
  },
  {
    value: "04",
    label: "Cuisnahuat",
    municipality: "19",
    department: "03"
  },
  {
    value: "05",
    label: "Santa Isabel Ishuatán",
    municipality: "19",
    department: "03"
  },
  {
    value: "06",
    label: "Izalco",
    municipality: "19",
    department: "03"
  },
  {
    value: "12",
    label: "San Julián",
    municipality: "19",
    department: "03"
  },
  {
    value: "01",
    label: "Acajutla",
    municipality: "20",
    department: "03"
  },
  {
    value: "04",
    label: "Citalá",
    municipality: "34",
    department: "04"
  },
  {
    value: "25",
    label: "San Ignacio",
    municipality: "34",
    department: "04"
  },
  {
    value: "12",
    label: "La Palma",
    municipality: "34",
    department: "04"
  },
  {
    value: "01",
    label: "Agua Caliente",
    municipality: "35",
    department: "04"
  },
  {
    value: "08",
    label: "Dulce Nombre de María",
    municipality: "35",
    department: "04"
  },
  {
    value: "10",
    label: "El Paraíso",
    municipality: "35",
    department: "04"
  },
  {
    value: "13",
    label: "La Reina",
    municipality: "35",
    department: "04"
  },
  {
    value: "16",
    label: "Nueva Concepción",
    municipality: "35",
    department: "04"
  },
  {
    value: "22",
    label: "San Fernando",
    municipality: "35",
    department: "04"
  },
  {
    value: "24",
    label: "San Francisco Morazán",
    municipality: "35",
    department: "04"
  },
  {
    value: "31",
    label: "San Rafael",
    municipality: "35",
    department: "04"
  },
  {
    value: "32",
    label: "Santa Rita",
    municipality: "35",
    department: "04"
  },
  {
    value: "33",
    label: "Tejutla",
    municipality: "35",
    department: "04"
  },
  {
    value: "02",
    label: "Arcatao",
    municipality: "36",
    department: "04"
  },
  {
    value: "03",
    label: "Azacualpa",
    municipality: "36",
    department: "04"
  },
  {
    value: "05",
    label: "Comalapa",
    municipality: "36",
    department: "04"
  },
  {
    value: "06",
    label: "Concepción Quezaltepeque",
    municipality: "36",
    department: "04"
  },
  {
    value: "07",
    label: "Chalatenango",
    municipality: "36",
    department: "04"
  },
  {
    value: "09",
    label: "El Carrizal",
    municipality: "36",
    department: "04"
  },
  {
    value: "11",
    label: "La Laguna",
    municipality: "36",
    department: "04"
  },
  {
    value: "14",
    label: "Las Vueltas",
    municipality: "36",
    department: "04"
  },
  {
    value: "15",
    label: "Nombre de Jesús",
    municipality: "36",
    department: "04"
  },
  {
    value: "17",
    label: "Nueva Trinidad",
    municipality: "36",
    department: "04"
  },
  {
    value: "18",
    label: "Ojos de Agua",
    municipality: "36",
    department: "04"
  },
  {
    value: "19",
    label: "Potonico",
    municipality: "36",
    department: "04"
  },
  {
    value: "20",
    label: "San Antonio de la Cruz",
    municipality: "36",
    department: "04"
  },
  {
    value: "21",
    label: "San Antonio Los Ranchos",
    municipality: "36",
    department: "04"
  },
  {
    value: "26",
    label: "San Isidro Labrador",
    municipality: "36",
    department: "04"
  },
  {
    value: "23",
    label: "San Francisco Lempa",
    municipality: "36",
    department: "04"
  },
  {
    value: "27",
    label: "San José Cancasque",
    municipality: "36",
    department: "04"
  },
  {
    value: "28",
    label: "San José Las Flores",
    municipality: "36",
    department: "04"
  },
  {
    value: "29",
    label: "San Luis del Carmen",
    municipality: "36",
    department: "04"
  },
  {
    value: "30",
    label: "San Miguel de Mercedes",
    municipality: "36",
    department: "04"
  },
  {
    value: "12",
    label: "Quezaltepeque",
    municipality: "23",
    department: "05"
  },
  {
    value: "16",
    label: "San Matías",
    municipality: "23",
    department: "05"
  },
  {
    value: "17",
    label: "San Pablo Tacachico",
    municipality: "23",
    department: "05"
  },
  {
    value: "02",
    label: "Ciudad Arce",
    municipality: "24",
    department: "05"
  },
  {
    value: "15",
    label: "San Juan Opico",
    municipality: "24",
    department: "05"
  },
  {
    value: "03",
    label: "Colón",
    municipality: "25",
    department: "05"
  },
  {
    value: "07",
    label: "Jayaque",
    municipality: "25",
    department: "05"
  },
  {
    value: "13",
    label: "Sacacoyo",
    municipality: "25",
    department: "05"
  },
  {
    value: "19",
    label: "Talnique",
    municipality: "25",
    department: "05"
  },
  {
    value: "21",
    label: "Tepecoyo",
    municipality: "25",
    department: "05"
  },
  {
    value: "01",
    label: "Antiguo Cuscatlán",
    municipality: "26",
    department: "05"
  },
  {
    value: "06",
    label: "Huizúcar",
    municipality: "26",
    department: "05"
  },
  {
    value: "10",
    label: "Nuevo Cuscatlán",
    municipality: "26",
    department: "05"
  },
  {
    value: "14",
    label: "San José Villanueva",
    municipality: "26",
    department: "05"
  },
  {
    value: "22",
    label: "Zaragoza",
    municipality: "26",
    department: "05"
  },
  {
    value: "05",
    label: "Chiltiupán",
    municipality: "27",
    department: "05"
  },
  {
    value: "08",
    label: "Jicalapa",
    municipality: "27",
    department: "05"
  },
  {
    value: "09",
    label: "La Libertad",
    municipality: "27",
    department: "05"
  },
  {
    value: "18",
    label: "Tamanique",
    municipality: "27",
    department: "05"
  },
  {
    value: "20",
    label: "Teotepeque",
    municipality: "27",
    department: "05"
  },
  {
    value: "04",
    label: "Comasagua",
    municipality: "28",
    department: "05"
  },
  {
    value: "11",
    label: "Santa Tecla",
    municipality: "28",
    department: "05"
  },
  {
    value: "01",
    label: "Aguilares",
    municipality: "20",
    department: "06"
  },
  {
    value: "05",
    label: "El Paisnal",
    municipality: "20",
    department: "06"
  },
  {
    value: "06",
    label: "Guazapa",
    municipality: "20",
    department: "06"
  },
  {
    value: "02",
    label: "Apopa",
    municipality: "21",
    department: "06"
  },
  {
    value: "09",
    label: "Nejapa",
    municipality: "21",
    department: "06"
  },
  {
    value: "07",
    label: "Ilopango",
    municipality: "22",
    department: "06"
  },
  {
    value: "13",
    label: "San Martín",
    municipality: "22",
    department: "06"
  },
  {
    value: "17",
    label: "Soyapango",
    municipality: "22",
    department: "06"
  },
  {
    value: "18",
    label: "Tonacatepeque",
    municipality: "22",
    department: "06"
  },
  {
    value: "03",
    label: "Ayutuxtepeque",
    municipality: "23",
    department: "06"
  },
  {
    value: "04",
    label: "Cuscatancingo",
    municipality: "23",
    department: "06"
  },
  {
    value: "08",
    label: "Mejicanos",
    municipality: "23",
    department: "06"
  },
  {
    value: "14",
    label: "San Salvador",
    municipality: "23",
    department: "06"
  },
  {
    value: "19",
    label: "Delgado",
    municipality: "23",
    department: "06"
  },
  {
    value: "10",
    label: "Panchimalco",
    municipality: "24",
    department: "06"
  },
  {
    value: "11",
    label: "Rosario de Mora",
    municipality: "24",
    department: "06"
  },
  {
    value: "12",
    label: "San Marcos",
    municipality: "24",
    department: "06"
  },
  {
    value: "15",
    label: "Santiago Texacuangos",
    municipality: "24",
    department: "06"
  },
  {
    value: "16",
    label: "Santo Tomás",
    municipality: "24",
    department: "06"
  },
  {
    value: "06",
    label: "Oratorio de Concepción",
    municipality: "17",
    department: "07"
  },
  {
    value: "07",
    label: "San Bartolomé Perulapía",
    municipality: "17",
    department: "07"
  },
  {
    value: "09",
    label: "San José Guayabal",
    municipality: "17",
    department: "07"
  },
  {
    value: "10",
    label: "San Pedro Perulapán",
    municipality: "17",
    department: "07"
  },
  {
    value: "15",
    label: "Suchitoto",
    municipality: "17",
    department: "07"
  },
  {
    value: "01",
    label: "Candelaria",
    municipality: "18",
    department: "07"
  },
  {
    value: "02",
    label: "Cojutepeque",
    municipality: "18",
    department: "07"
  },
  {
    value: "03",
    label: "El Carmen",
    municipality: "18",
    department: "07"
  },
  {
    value: "04",
    label: "El Rosario",
    municipality: "18",
    department: "07"
  },
  {
    value: "05",
    label: "Monte San Juan",
    municipality: "18",
    department: "07"
  },
  {
    value: "08",
    label: "San Cristóbal",
    municipality: "18",
    department: "07"
  },
  {
    value: "11",
    label: "San Rafael Cedros",
    municipality: "18",
    department: "07"
  },
  {
    value: "12",
    label: "San Ramón",
    municipality: "18",
    department: "07"
  },
  {
    value: "13",
    label: "Santa Cruz Analquito",
    municipality: "18",
    department: "07"
  },
  {
    value: "14",
    label: "Santa Cruz Michapa",
    municipality: "18",
    department: "07"
  },
  {
    value: "16",
    label: "Tenancingo",
    municipality: "18",
    department: "07"
  },
  {
    value: "01",
    label: "Cuyultitán",
    municipality: "23",
    department: "08"
  },
  {
    value: "05",
    label: "Olocuilta",
    municipality: "23",
    department: "08"
  },
  {
    value: "09",
    label: "San Francisco Chinameca",
    municipality: "23",
    department: "08"
  },
  {
    value: "11",
    label: "San Juan Talpa",
    municipality: "23",
    department: "08"
  },
  {
    value: "13",
    label: "San Luis Talpa",
    municipality: "23",
    department: "08"
  },
  {
    value: "15",
    label: "San Pedro Masahuat",
    municipality: "23",
    department: "08"
  },
  {
    value: "20",
    label: "Tapalhuaca",
    municipality: "23",
    department: "08"
  },
  {
    value: "02",
    label: "El Rosario",
    municipality: "24",
    department: "08"
  },
  {
    value: "03",
    label: "Jerusalén",
    municipality: "24",
    department: "08"
  },
  {
    value: "04",
    label: "Mercedes La Ceiba",
    municipality: "24",
    department: "08"
  },
  {
    value: "06",
    label: "Paraíso de Osorio",
    municipality: "24",
    department: "08"
  },
  {
    value: "07",
    label: "San Antonio Masahuat",
    municipality: "24",
    department: "08"
  },
  {
    value: "08",
    label: "San Emigdio",
    municipality: "24",
    department: "08"
  },
  {
    value: "12",
    label: "San Juan Tepezontes",
    municipality: "24",
    department: "08"
  },
  {
    value: "14",
    label: "San Miguel Tepezontes",
    municipality: "24",
    department: "08"
  },
  {
    value: "16",
    label: "San Pedro Nonualco",
    municipality: "24",
    department: "08"
  },
  {
    value: "18",
    label: "Santa María Ostuma",
    municipality: "24",
    department: "08"
  },
  {
    value: "19",
    label: "Santiago Nonualco",
    municipality: "24",
    department: "08"
  },
  {
    value: "22",
    label: "San Luis La Herradura",
    municipality: "24",
    department: "08"
  },
  {
    value: "10",
    label: "San Juan Nonualco",
    municipality: "25",
    department: "08"
  },
  {
    value: "17",
    label: "San Rafael Obrajuelo",
    municipality: "25",
    department: "08"
  },
  {
    value: "21",
    label: "Zacatecoluca",
    municipality: "25",
    department: "08"
  },
  {
    value: "01",
    label: "Cinquera",
    municipality: "10",
    department: "09"
  },
  {
    value: "03",
    label: "Ilobasco",
    municipality: "10",
    department: "09"
  },
  {
    value: "04",
    label: "Jutiapa",
    municipality: "10",
    department: "09"
  },
  {
    value: "07",
    label: "Tejutepeque",
    municipality: "10",
    department: "09"
  },
  {
    value: "02",
    label: "Guacotecti",
    municipality: "11",
    department: "09"
  },
  {
    value: "05",
    label: "San Isidro",
    municipality: "11",
    department: "09"
  },
  {
    value: "06",
    label: "Sensuntepeque",
    municipality: "11",
    department: "09"
  },
  {
    value: "08",
    label: "Victoria",
    municipality: "11",
    department: "09"
  },
  {
    value: "09",
    label: "Dolores",
    municipality: "11",
    department: "09"
  },
  {
    value: "01",
    label: "Apastepeque",
    municipality: "14",
    department: "10"
  },
  {
    value: "04",
    label: "Santa Clara",
    municipality: "14",
    department: "10"
  },
  {
    value: "05",
    label: "Santo Domingo",
    municipality: "14",
    department: "10"
  },
  {
    value: "06",
    label: "San Esteban Catarina",
    municipality: "14",
    department: "10"
  },
  {
    value: "07",
    label: "San Ildefonso",
    municipality: "14",
    department: "10"
  },
  {
    value: "08",
    label: "San Lorenzo",
    municipality: "14",
    department: "10"
  },
  {
    value: "09",
    label: "San Sebastián",
    municipality: "14",
    department: "10"
  },
  {
    value: "02",
    label: "Guadalupe",
    municipality: "15",
    department: "10"
  },
  {
    value: "03",
    label: "San Cayetano Istepeque",
    municipality: "15",
    department: "10"
  },
  {
    value: "10",
    label: "San Vicente",
    municipality: "15",
    department: "10"
  },
  {
    value: "11",
    label: "Tecoluca",
    municipality: "15",
    department: "10"
  },
  {
    value: "12",
    label: "Tepetitán",
    municipality: "15",
    department: "10"
  },
  {
    value: "13",
    label: "Verapaz",
    municipality: "15",
    department: "10"
  },
  {
    value: "01",
    label: "Alegría",
    municipality: "24",
    department: "11"
  },
  {
    value: "02",
    label: "Berlín",
    municipality: "24",
    department: "11"
  },
  {
    value: "05",
    label: "El Triunfo",
    municipality: "24",
    department: "11"
  },
  {
    value: "07",
    label: "Estanzuelas",
    municipality: "24",
    department: "11"
  },
  {
    value: "09",
    label: "Jucuapa",
    municipality: "24",
    department: "11"
  },
  {
    value: "11",
    label: "Mercedes Umaña",
    municipality: "24",
    department: "11"
  },
  {
    value: "12",
    label: "Nueva Granada",
    municipality: "24",
    department: "11"
  },
  {
    value: "16",
    label: "San Buenaventura",
    municipality: "24",
    department: "11"
  },
  {
    value: "21",
    label: "Santiago de María",
    municipality: "24",
    department: "11"
  },
  {
    value: "03",
    label: "California",
    municipality: "25",
    department: "11"
  },
  {
    value: "04",
    label: "Concepción Batres",
    municipality: "25",
    department: "11"
  },
  {
    value: "06",
    label: "Ereguayquín",
    municipality: "25",
    department: "11"
  },
  {
    value: "10",
    label: "Jucuarán",
    municipality: "25",
    department: "11"
  },
  {
    value: "13",
    label: "Ozatlán",
    municipality: "25",
    department: "11"
  },
  {
    value: "17",
    label: "San Dionisio",
    municipality: "25",
    department: "11"
  },
  {
    value: "18",
    label: "Santa Elena",
    municipality: "25",
    department: "11"
  },
  {
    value: "20",
    label: "Santa María",
    municipality: "25",
    department: "11"
  },
  {
    value: "22",
    label: "Tecapán",
    municipality: "25",
    department: "11"
  },
  {
    value: "23",
    label: "Usulután",
    municipality: "25",
    department: "11"
  },
  {
    value: "08",
    label: "Jiquilisco",
    municipality: "26",
    department: "11"
  },
  {
    value: "14",
    label: "Puerto El Triunfo",
    municipality: "26",
    department: "11"
  },
  {
    value: "15",
    label: "San Agustín",
    municipality: "26",
    department: "11"
  },
  {
    value: "19",
    label: "San Francisco Javier",
    municipality: "26",
    department: "11"
  },
  {
    value: "01",
    label: "Carolina",
    municipality: "21",
    department: "12"
  },
  {
    value: "02",
    label: "Ciudad Barrios",
    municipality: "21",
    department: "12"
  },
  {
    value: "04",
    label: "Chapeltique",
    municipality: "21",
    department: "12"
  },
  {
    value: "11",
    label: "Nuevo Edén de San Juan",
    municipality: "21",
    department: "12"
  },
  {
    value: "13",
    label: "San Antonio del Mosco",
    municipality: "21",
    department: "12"
  },
  {
    value: "14",
    label: "San Gerardo",
    municipality: "21",
    department: "12"
  },
  {
    value: "16",
    label: "San Luis de La Reina",
    municipality: "21",
    department: "12"
  },
  {
    value: "19",
    label: "Sesori",
    municipality: "21",
    department: "12"
  },
  {
    value: "03",
    label: "Comacarán",
    municipality: "22",
    department: "12"
  },
  {
    value: "06",
    label: "Chirilagua",
    municipality: "22",
    department: "12"
  },
  {
    value: "09",
    label: "Moncagua",
    municipality: "22",
    department: "12"
  },
  {
    value: "12",
    label: "Quelepa",
    municipality: "22",
    department: "12"
  },
  {
    value: "17",
    label: "San Miguel",
    municipality: "22",
    department: "12"
  },
  {
    value: "20",
    label: "Uluazapa",
    municipality: "22",
    department: "12"
  },
  {
    value: "05",
    label: "Chinameca",
    municipality: "23",
    department: "12"
  },
  {
    value: "07",
    label: "El Tránsito",
    municipality: "23",
    department: "12"
  },
  {
    value: "08",
    label: "Lolotique",
    municipality: "23",
    department: "12"
  },
  {
    value: "10",
    label: "Nueva Guadalupe",
    municipality: "23",
    department: "12"
  },
  {
    value: "15",
    label: "San Jorge",
    municipality: "23",
    department: "12"
  },
  {
    value: "18",
    label: "San Rafael Oriente",
    municipality: "23",
    department: "12"
  },
  {
    value: "01",
    label: "Arambala",
    municipality: "27",
    department: "13"
  },
  {
    value: "02",
    label: "Cacaopera",
    municipality: "27",
    department: "13"
  },
  {
    value: "03",
    label: "Corinto",
    municipality: "27",
    department: "13"
  },
  {
    value: "07",
    label: "El Rosario",
    municipality: "27",
    department: "13"
  },
  {
    value: "10",
    label: "Joateca",
    municipality: "27",
    department: "13"
  },
  {
    value: "11",
    label: "Jocoaitique",
    municipality: "27",
    department: "13"
  },
  {
    value: "14",
    label: "Meanguera",
    municipality: "27",
    department: "13"
  },
  {
    value: "16",
    label: "Perquín",
    municipality: "27",
    department: "13"
  },
  {
    value: "18",
    label: "San Fernando",
    municipality: "27",
    department: "13"
  },
  {
    value: "20",
    label: "San Isidro",
    municipality: "27",
    department: "13"
  },
  {
    value: "24",
    label: "Torola",
    municipality: "27",
    department: "13"
  },
  {
    value: "04",
    label: "Chilanga",
    municipality: "28",
    department: "13"
  },
  {
    value: "05",
    label: "Delicias de Concepción",
    municipality: "28",
    department: "13"
  },
  {
    value: "06",
    label: "El Divisadero",
    municipality: "28",
    department: "13"
  },
  {
    value: "08",
    label: "Gualococti",
    municipality: "28",
    department: "13"
  },
  {
    value: "09",
    label: "Guatajiagua",
    municipality: "28",
    department: "13"
  },
  {
    value: "12",
    label: "Jocoro",
    municipality: "28",
    department: "13"
  },
  {
    value: "13",
    label: "Lolotiquillo",
    municipality: "28",
    department: "13"
  },
  {
    value: "15",
    label: "Osicala",
    municipality: "28",
    department: "13"
  },
  {
    value: "17",
    label: "San Carlos",
    municipality: "28",
    department: "13"
  },
  {
    value: "19",
    label: "San Francisco Gotera",
    municipality: "28",
    department: "13"
  },
  {
    value: "21",
    label: "San Simón",
    municipality: "28",
    department: "13"
  },
  {
    value: "22",
    label: "Sensembra",
    municipality: "28",
    department: "13"
  },
  {
    value: "23",
    label: "Sociedad",
    municipality: "28",
    department: "13"
  },
  {
    value: "25",
    label: "Yamabal",
    municipality: "28",
    department: "13"
  },
  {
    value: "26",
    label: "Yoloaiquín",
    municipality: "28",
    department: "13"
  },
  {
    value: "01",
    label: "Anamorós",
    municipality: "19",
    department: "14"
  },
  {
    value: "02",
    label: "Bolívar",
    municipality: "19",
    department: "14"
  },
  {
    value: "03",
    label: "Concepción de Oriente",
    municipality: "19",
    department: "14"
  },
  {
    value: "06",
    label: "El Sauce",
    municipality: "19",
    department: "14"
  },
  {
    value: "09",
    label: "Lislique",
    municipality: "19",
    department: "14"
  },
  {
    value: "11",
    label: "Nueva Esparta",
    municipality: "19",
    department: "14"
  },
  {
    value: "12",
    label: "Pasaquina",
    municipality: "19",
    department: "14"
  },
  {
    value: "13",
    label: "Polorós",
    municipality: "19",
    department: "14"
  },
  {
    value: "15",
    label: "San José La Fuente",
    municipality: "19",
    department: "14"
  },
  {
    value: "16",
    label: "Santa Rosa de Lima",
    municipality: "19",
    department: "14"
  },
  {
    value: "04",
    label: "Conchagua",
    municipality: "20",
    department: "14"
  },
  {
    value: "05",
    label: "El Carmen",
    municipality: "20",
    department: "14"
  },
  {
    value: "07",
    label: "Intipucá",
    municipality: "20",
    department: "14"
  },
  {
    value: "08",
    label: "La Unión",
    municipality: "20",
    department: "14"
  },
  {
    value: "10",
    label: "Meanguera del Golfo",
    municipality: "20",
    department: "14"
  },
  {
    value: "14",
    label: "San Alejo",
    municipality: "20",
    department: "14"
  },
  {
    value: "17",
    label: "Yayantique",
    municipality: "20",
    department: "14"
  },
  {
    value: "18",
    label: "Yucuaiquín",
    municipality: "20",
    department: "14"
  }
]
